export var WebSocketsServiceEvent;
(function (WebSocketsServiceEvent) {
    WebSocketsServiceEvent["UserRoleMessageReceived"] = "WebSocketMessageReceived";
    WebSocketsServiceEvent["NotificationAddedForUser"] = "NotificationAddedForUser";
    WebSocketsServiceEvent["MessageSentToUser"] = "MessageSentToUser";
    WebSocketsServiceEvent["UserInvitedToSharedVault"] = "UserInvitedToSharedVault";
    WebSocketsServiceEvent["ItemsChangedOnServer"] = "ItemsChangedOnServer";
})(WebSocketsServiceEvent || (WebSocketsServiceEvent = {}));
